import { ACTION_TYPES } from "./types";
const { SET_USER_PLANS, SET_PLAN_PURCHASE_BILL } = ACTION_TYPES;

export const setUserPlans = (payload) => {
  return (dispatch) => {
    dispatch({
      type: SET_USER_PLANS,
      payload,
    });
  };
};

export const updatePurchaseBill = (payload) => {
  return (dispatch) => {
    dispatch({
      type: SET_PLAN_PURCHASE_BILL,
      payload,
    });
  };
};
